import React from 'react'

const Icon = (props, context) => (
  <img
    alt=""
    src={`${context.hostname || ''}/static/images/${props.name}.svg`}
    {...{ ...props, name: undefined }} // pass other properties
  />
)

Icon.contextTypes = {
  hostname: React.PropTypes.string,
}

export default Icon



// WEBPACK FOOTER //
// ./components/visual/Icon.js